















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Deck as DeckType } from '@/store';
import Chip from '@/components/Chip.vue';

@Component({
  components: { Chip },
})
export default class Deck extends Vue {
  @Prop({ type: Object, default: null }) public readonly deck!: DeckType;

  get tags() {
    return this.deck.tags;
  }

  get numCards() {
    return this.deck.cards.length;
  }
}
